module.exports = __webpack_public_path__ + "img/img-6.770738a9.svg";